import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class FilterGroup extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    classModifier: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    tooltip: PropTypes.func
  };

  static defaultProps = {
    label: '',
    classModifier: '',
    children: null,
    tooltip: () => {}
  };

  getClassName = () => {
    const { classModifier } = this.props;

    const modifier = classModifier ? `filter-group--${classModifier}` : '';
    return classNames('filter-group', modifier);
  };

  render() {
    const { children, label, tooltip } = this.props;

    return (
      <div className={this.getClassName()}>
        <div className="filter-group-left-side">
          <div className="filter-group-left-side__label">
            <span>{label}</span>
            {tooltip()}
          </div>
        </div>
        <div className="filter-group-right-side">{children}</div>
      </div>
    );
  }
}

export default FilterGroup;
